import React from "react";
import * as styles from "./devices-toolbar.module.scss";
import IconSearch from "../../../../../dynamicicons/icon-search";
import VelavuInput from "../../../../../elements/velavu-input";
import IconClose from "../../../../../dynamicicons/icon-close";
import IconFilterList from "../../../../../dynamicicons/icon-filter-list";
import VelavuIconButton from "../../../../../elements/velavu-icon-button";
import FloorFilter from "../../../../../data/floor-filter";
import FloorFilterButton from "../../../../../elements/floor-filter-button";

export interface DevicesToolbarProps {
	searchText: string;
	setSearchText: (searchText: string) => void;

	levelSelection?: number;
	onChangeFloor: (filter: FloorFilter) => void;

	highlightFilter: boolean;
	showFilterMenu: boolean;
	onClickShowFilterMenu: () => void;
}

export default function DevicesToolbar(props: DevicesToolbarProps) {
	const filterColor = props.highlightFilter ? "#3A58E2" : "#5F718C";

	return (
		<div className={styles.toolbar}>
			<VelavuInput
				className={styles.searchBar}
				leadingIcon={<IconSearch size={16} color="#00255D" />}
				type={"search"}
				placeholder="Search"
				value={props.searchText}
				onChange={props.setSearchText}
				fullWidth
			/>

			<FloorFilterButton
				selection={props.levelSelection}
				onChange={props.onChangeFloor}
			/>

			<VelavuIconButton
				highlight={props.highlightFilter}
				onClick={props.onClickShowFilterMenu}
			>
				{props.showFilterMenu ? (
					<IconClose color={filterColor} />
				) : (
					<IconFilterList color={filterColor} />
				)}
			</VelavuIconButton>
		</div>
	);
}
